<template>
  <div v-loading.body="loading">
    <div
      v-if="resData"
      class="row"
      :gutter="20"
      type="flex"
      align="middle"
      justify="start"
    >
      <div
        v-for="item in computedOriginList"
        :key="item.origin_id"
        class="status"
        :class="{ active: origin === item.origin_id }"
        @click="selectOrigin(item.origin_id)"
      >
        {{ item.origin_name }}
      </div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-select
                    v-model="search_type"
                    placeholder=""
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in search_options"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-left: -15px; width: 165px">
                  <el-input
                    v-model="search_value"
                    placeholder="请输入搜索内容"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.f_type"
                    placeholder="理赔类型"
                    style="width: 150px"
                    @change="setType"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in computedClaimTypes"
                      :key="item.claims_type_id"
                      :label="item.title"
                      :value="item.claims_type_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.type"
                    placeholder="理赔二级类型"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in types"
                      :key="item.claims_type_id"
                      :label="item.title"
                      :value="item.claims_type_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.cb_status"
                    placeholder="是否拆包"
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in cb_options2"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.cb_type"
                    placeholder="是否实物拆包"
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in cb_options"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="登记时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.service_desc"
                    placeholder="客服备注"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="退款时间：">
                  <el-date-picker
                    v-model="form.refund_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.problem_id"
                    placeholder="问题类型"
                    style="width: 150px"
                    @change="setProblem"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in computedIssueTypes"
                      :key="item.problem_id"
                      :label="item.problem_name"
                      :value="item.problem_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.second_problem_id"
                    placeholder="问题描述"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in problems"
                      :key="item.problem_id"
                      :label="item.problem_name"
                      :value="item.problem_id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.handle_status"
                    placeholder="处理状态"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in resData.handle_status"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.status"
                    placeholder="理赔状态"
                    style="width: 150px"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in status_options"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="拆包时间：">
                  <el-date-picker
                    v-model="form.back_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="申请时间：">
                  <el-date-picker
                    v-model="form.apply_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['06:00:00', '06:00:00']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="" @click="reset">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <!--<el-input size="mini" style="width: 120px;"  placeholder="期数"></el-input>-->
          <el-button
            slot="trigger"
            style="margin-left: auto"
            size="mini"
            type="primary"
            @click="openSplit"
            >拆工单理赔</el-button
          >
          <el-button
            slot="trigger"
            size="mini"
            type="primary"
            @click="openClaims"
            >申请理赔</el-button
          >
          <el-button type="primary" size="mini" @click="exportExcel">
            导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="right"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="work_id"
              label="工单ID"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="back_shipping_num"
              label="用户寄回运单号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="shipping_nums"
              label="仓库拆包寄回运单号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="add_time"
              label="登记时间"
            ></el-table-column>
            <el-table-column align="center" label="商品图片">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.imgs.length > 0"
                  style="width: 70px; height: 70px"
                >
                  <img
                    :src="scope.row.imgs[0]"
                    style="width: 100%; height: 100%"
                    @click="showImages(scope.row.imgs)"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              show-overflow-tooltip
              prop="goods_name"
              label="商品名称"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goods_no"
              label="商品货号"
            ></el-table-column>
            <el-table-column align="center" label="颜色/尺码/件数">
              <template slot-scope="scope">
                {{ scope.row.co_val }}/ {{ scope.row.si_val }}/
                {{ scope.row.goods_number }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="sku"
              label="sku"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="refund_goods_money"
              label="商品金额"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="refund_money"
              label="退款金额"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="adopt_refund_time"
              label="退款时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="handle_user"
              label="发布人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="service_order_handle_status"
              label="处理状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="problem_type"
              label="问题类型"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="problem_name"
              label="问题描述"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="service_desc"
              label="客服备注"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="back_time"
              label="拆包时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="back_admin"
              label="拆包人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="dbids"
              label="有实物打标id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="no_back_num"
              label="无实物件数"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="back_remark"
              label="拆包备注"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="claims_detail_back_status"
              label="拆包状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="claims_detail_status"
              label="理赔状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="check_remark"
              label="审核备注"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="申请时间/申请人"
            >
              <template slot-scope="scope">
                {{ scope.row.create_time }}/
                {{ scope.row.apply_admin }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="理赔类型">
              <template slot-scope="scope">
                {{ scope.row.f_claims_type }}/
                {{ scope.row.claims_type }}
              </template>
            </el-table-column>
            <!--<el-table-column align="center" prop="dbid" label="快递公司"></el-table-column>-->
            <el-table-column
              align="center"
              prop=""
              label="计费方式/计费比例/商品理赔"
            >
              <template slot-scope="scope">
                {{ scope.row.claims_billing_method }}/
                {{ scope.row.billing_rate }}/{{ scope.row.money }}
              </template>
            </el-table-column>
            <!--<el-table-column align="center" prop="billing_rate" label="计费比例"></el-table-column>-->
            <!--<el-table-column align="center" prop="claims_money" label="理赔金额"></el-table-column>-->
            <el-table-column
              align="center"
              prop="dbid"
              label="操作"
              fixed="right"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.status == 0 || scope.row.status == 3">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="handleDetail(scope.row.work_id)"
                    >拆包</el-button
                  >
                </div>
                <div v-if="scope.row.status == 1 || scope.row.status == 2">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="handleDetail(scope.row.work_id)"
                    >查看</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <!--拆包-->
    <div v-if="isShow">
      <UnPackage :work-id="work_id" @onCloseDialog="onCloseDialog" />
    </div>
    <!--理赔-->
    <div v-if="isClaimsVisible">
      <Claims
        :work-ids="multipleSelection"
        :claims-detail-id="claims_detail_id"
        :origin="origin"
        @onCloseDialog="onCloseDialog"
      ></Claims>
    </div>
    <!--拆分-->
    <div v-if="is_Split">
      <Split
        :claims_detail_id="claims_detail_id"
        @onCloseDialog="onCloseDialog"
      ></Split>
    </div>
    <preview-image
      :imgs="images"
      :show="showbox"
      @closeBox="closeBox()"
    ></preview-image>
  </div>
</template>

<script>
import UnPackage from "./components/UnPackage.vue";
import Split from "./components/Split.vue";
import Claims from "./components/Claims.vue";
import PreviewImage from "../../components/PreviewImage.vue";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "RefundClaimList",
  components: {
    Claims,
    Split,
    UnPackage,
    PreviewImage,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      is_Split: false,
      claims_detail_id: [],
      types: [],
      problems: [],
      isShow: false,
      isClaimsVisible: false,
      images: [],
      showbox: false,
      fileList: [],
      clear_action: "",
      logVisible: false,
      clearVisible: false,
      resData: {},
      form: {
        pagesize: 50,
        create_time: this.defaultDate(),
        apply_time: this.defaultDate(),
      },
      search_type: "work_id",
      search_options: [
        { key: "work_id", name: "工单id" },
        { key: "goods_no", name: "商品货号" },
        { key: "sku", name: "sku" },
        { key: "back_admin", name: "拆包人" },
        { key: "user_mobile", name: "用户手机" },
        { key: "back_shipping_num", name: "寄回运单号" },
        { key: "user_id", name: "用户ID" },
        { key: "order_mobile", name: "收货人手机" },
        { key: "order_sn", name: "订单号" },
        { key: "out_shipping_num", name: "寄出运单号" },
      ],
      status_options: [
        { key: 0, name: "无(已拆包)" },
        { key: 1, name: "待审核" },
        { key: 2, name: "审核通过" },
        { key: 3, name: "驳回" },
      ],
      cb_options: [
        { key: 1, name: "是" },
        { key: 2, name: "否" },
      ],
      cb_options2: [
        { key: 1, name: "已拆包" },
        { key: 2, name: "未拆包" },
      ],
      search_value: "",
      origin_list: [
        {
          origin_id: 1,
          origin_name: "广州",
        },
        {
          origin_id: 2,
          origin_name: "杭州",
        },
      ],
      origin: 1,
      space: "",
      ss_id: 0,
      loading: false,
      tableLoading: false,
      url: "/erp/claims/index",
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      logcurPage: 1,
      logInfo: {},
      multipleSelection: [],
    };
  },
  computed: {
    filteredForm() {
      Object.keys(this.form).forEach((key) => {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      });
      return this.form;
    },
    computedOriginList() {
      return this.origin_list.filter((origin) => origin.origin_id !== -1);
    },
    computedClaimTypes() {
      return this.resData?.type?.filter((t) => t.parent_id === "0");
    },
    computedIssueTypes() {
      return this.resData?.problem?.filter((p) => p.parent_id === "0");
    },
  },
  methods: {
    defaultDate() {
      return this.$excalibur.getDateTimeOnHours(-15, 6);
    },
    setType(value) {
      if (Number(value) !== 0) {
        this.types = [];

        Object.keys(this.resData.type).forEach((key) => {
          if (Number(value) === Number(this.resData.type[key].parent_id)) {
            this.types.push(this.resData.type[key]);
          }
        });
      }
    },
    setProblem(value) {
      if (Number(value) !== 0) {
        this.problems = [];

        Object.keys(this.resData.problem).forEach((key) => {
          if (Number(value) === Number(this.resData.problem[key].parent_id)) {
            this.problems.push(this.resData.problem[key]);
          }
        });
      }
    },
    onCloseDialog() {
      this.fetchData();
      this.isShow = false;
      this.isClaimsVisible = false;
      this.is_Split = false;
    },
    handleDetail(id) {
      this.isShow = true;
      this.work_id = Number(id);
    },
    openClaims() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("请勾选工单");
        return;
      }
      this.isClaimsVisible = true;
    },
    openSplit() {
      this.is_Split = true;
    },
    showImages(img) {
      this.showbox = true;
      this.images = img;
    },
    closeBox() {
      this.showbox = false;
    },
    selectOrigin(originId) {
      this.origin = originId;
      this.form.origin = originId;
      this.fetchData(true);
    },
    addColor() {
      // if (columnIndex === 15) {
      //     return 'blue-cell';
      // }
    },
    exportExcel() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      if (this.search_value !== "") {
        Object.keys(this.search_options).forEach((key) => {
          this.form[this.search_options[key].key] = "";
        });
        this.form[this.search_type] = this.search_value;
      } else {
        Object.keys(this.search_options).forEach((key) => {
          this.form[this.search_options[key].key] = "";
        });
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      const claimsDetailId = [];
      Object.keys(val).forEach((key) => {
        multipleSelection[key] = val[key].work_id;
        if (val[key].claims_detail_id) {
          claimsDetailId[key] = val[key].claims_detail_id;
        }
      });
      this.multipleSelection = multipleSelection;
      this.claims_detail_id = claimsDetailId;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.fetchData(true);
    },

    trim(str, isGlobal) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (isGlobal.toLowerCase() === "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    reset() {
      this.search_value = "";
      this.form = {};
      this.form.page = 1;
      this.form.pagesize = 50;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/claims/Index.vue